import { Avatar, Box, Stack } from '@mui/material';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useCallback, useEffect, useState } from 'react';
import { IReimbursements, getReimbursements } from 'API/Reimbursements';
import { CustomMetaTitle, LinkReturnToMain } from 'Components';
import { Title } from './Title';
import { Item } from './Item';
import { ReimbursementsBgImg } from 'Images';
export const Reimbursements = () => {
  const [items, setItems] = useState<IReimbursements[]>([]);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);
  const isDesktop = useIsDesktop();

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const init = useCallback(async () => {
    const res = await getReimbursements();

    if (res) {
      setItems(res);
    }
  }, []);

  useEffect(() => {
    init();
  }, [init, imposterId]);

  return (
    <Stack
      gap={isDesktop ? '32px' : '24px'}
      marginBottom={'80px'}
      maxWidth={'1000px'}
    >
      <CustomMetaTitle title={dictionary.title} />
      <LinkReturnToMain />
      <Title />
      <Stack
        spacing={0}
        sx={{
          width: '100%',
          flexDirection: isDesktop ? 'row' : 'column',
          flexWrap: isDesktop ? 'wrap' : 'nowrap',
        }}
      >
        {items.map((item, index) => (
          <Box
            key={index}
            sx={{
              width: isDesktop ? 'calc(33.33% - 48px)' : '100%',
              mb: isDesktop ? 3 : 4,
              mr: isDesktop ? 3 : 0,
              flexGrow: 0,
              flexShrink: 0,
              maxWidth: isDesktop ? 'calc(33.33% - 48px)' : '100%',
            }}
          >
            <Item item={item} />
          </Box>
        ))}
      </Stack>
      {isDesktop && (
        <Avatar
          src={ReimbursementsBgImg}
          alt=''
          sx={{ width: '400px', height: '280px', mt: 5, alignSelf: 'end' }}
        />
      )}
    </Stack>
  );
};
